import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, SimpleChanges, AfterViewInit, OnDestroy, ElementRef, NgZone } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormControl } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select'
import { PastEmploymentInfoService } from 'src/app/services/past-employment-info.service';
import { Tools } from 'src/app/models/tools';
import { PastEmployerInfoDTO } from 'src/app/DTOs/PastEmployerInfoDTO';
import { PastEmployerInfo } from 'src/app/models/pastEmployerInfo';
import { ValidationService } from 'src/app/services/validation.service';
import { Province } from 'src/app/models/province';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CountryCode } from 'src/app/data/country-code';
import moment from 'moment';
import 'moment/locale/fr';
import {default as data} from 'src/assets/i18n/country.json';
import { DynamicScriptsService, Maps } from 'src/app/services/dynamic-scripts.service';
import { TranslateModule } from '@ngx-translate/core';
import { FieldErrorDisplayComponent } from 'src/app/components/field-error-display/field-error-display.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommonModule } from '@angular/common';
import { IntlTelInputComponent } from 'src/app/components/intl-tel-input/intl-tel-input.component';
import { MatInputModule } from '@angular/material/input';
import { datePickerValidationCheckImpl, MY_FORMATS, loadDateToMoment } from 'src/app/services/sharedHelper';

@Component({
  selector: 'app-add-employer-modal',
  templateUrl: './add-employer-modal.component.html',
  styleUrls: ['./add-employer-modal.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    CountryCode,
  ],
  imports: [TranslateModule,
    FieldErrorDisplayComponent,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    CommonModule,
    IntlTelInputComponent,
    MatInputModule
  ],
  standalone: true
})


// This class is responsible for Gathering info about past employement (i.e name , address, occupation etc.)
export class AddEmployerModalComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('cancelBtn') cancelBtn: any;
  public employedToMinimumDate: Date;
  public maxDate = new Date();
  public minYear = new Date(1900, 0, 1);
  public lowerthanZero: boolean = false;
  public greterthantwentyfor: boolean = false;
  public istoolform: boolean = true;
  public isNumber: boolean = false;
  public isTool: boolean = false;
  public isCanadaOrUsa: boolean = true;
  public invalidHours: boolean = false;
  public tools: Array<Tools> = new Array<Tools>();
  public toolSearchString: string;
  public keyword = 'toolEnName';
  public toolList: string[];
  public currentLang: string;
  public toolListOverLimit: boolean;
  public fromdate: Date;
  public todate: Date;
  public isfromdate: boolean = false;
  public issubmitForm: boolean = false;
  public issubmit: boolean = false;
  public toolInput = new UntypedFormControl();
  public filteredOptions: Observable<string[]>;
  public isCanada: boolean = true;
  checkDot: boolean = false;
  public countryList: string[];
  public provinceListCanada: Array<Province> = data.provinceListCanada;
  public provinceListCanadaFrench: Array<Province> = data.provinceListCanadaFrench;
  public provinceListUSA: Array<Province> = data.provinceListUSA;
  public provinceListUSAFrench: Array<Province> = data.provinceListUSAFrench;
  public countryListEnglish: any = data.countryListEnglish;
  public countryListFrench: any = data.countryListFrench;
  public provinceList: Array<Province> = this.provinceListCanada.slice(0);

  @Input() public claimId: number;
  @Input() public pastEmployerInfo: PastEmployerInfo;
  @Input() public predefinedToolList: Array<string> = new Array<string>();
  @Output() addOrUpdatePastEmployment = new EventEmitter<PastEmployerInfoDTO>();

  employerForm = new UntypedFormGroup({
    employerName: new UntypedFormControl('', [Validators.required, Validators.pattern(`^[A-Za-z0-9\-\Çéâêîôûàèùëïü./'#@%&:;,\\n ]*$`)]),
    stillInBusiness: new UntypedFormControl('', Validators.required),
    employerAddress: new UntypedFormControl(''),
    jobTitle: new UntypedFormControl('', [Validators.required, Validators.pattern(`^[A-Za-z0-9\-\Çéâêîôûàèùëïü./'#@%&:;,\\n ]*$`)]),
    employedFrom: new FormControl<moment.Moment | null>( null, Validators.required),
    employedTo: new FormControl<moment.Moment | null>(null, Validators.required),

    country: new UntypedFormControl('Canada', Validators.required),
    provinceState: new UntypedFormControl('ON', Validators.required),
    employerPhoneNumber: new UntypedFormControl(''),
  });

  @ViewChild('employerAddress')
  public employerAddress: ElementRef;

  toolsForm = new UntypedFormGroup({
    toolName: new UntypedFormControl(null, [Validators.required, Validators.maxLength(250)]),
    // hoursUsed: new FormControl(null, [Validators.required, Validators.pattern('^(\d*\.)?\d+$')]),
    hoursUsed: new UntypedFormControl(null, [Validators.required, Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')]),
  });

  constructor(
    private pastEmploymentService: PastEmploymentInfoService,
    private validationService: ValidationService,
    private countryCodeData: CountryCode,
    public googleplaces: DynamicScriptsService,
    private ngZone: NgZone,
    private dateAdapter: DateAdapter<moment.Moment>
  ) { }

  ngOnInit() {

    const lang = sessionStorage.getItem('currentLang');

    if (lang) {
      if (lang.includes('en')) {
        this.currentLang = 'toolEnName';
      } else {
        this.currentLang = 'toolFrName';
      }

      this.dateAdapter.setLocale(lang);
    }

    this.googleplaces.api.then(maps => {
      this.initAutocomplete(maps, this.employerAddress?.nativeElement);

    });


    // this.getAllTools();

  }
  initAutocomplete(maps: Maps, element) {
    const autocomplete = new maps.places.Autocomplete(element);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        this.addressChange(autocomplete.getPlace());
      });
    });
  }

  ngAfterViewInit() {
    this.employerForm.markAsUntouched();
  }
  ngOnDestroy() {
    this.cancelBtn.nativeElement.click();
  }

  datePickerValidationCheck(form: UntypedFormGroup, field: string, validadtionType: string): boolean {
    return datePickerValidationCheckImpl(form, field, validadtionType);
  }

  replaceSpaces(formControl: string) {
    let value = this.employerForm.get(formControl).value;
    value = value.replace(/\s\s+/g, ' ');
    if (value) {
      this.employerForm.get(formControl).setValue(value);
    }
  }

  trimpaces(formControl: string) {
    const value = this.employerForm.get(formControl).value;
    if (value) {
      this.employerForm.get(formControl).setValue(value.trim());
    }
  }


  updateCountryList() {
    if (sessionStorage.getItem('currentLang') === 'fr') {
      this.countryList = this.countryListFrench;
    } else {
      this.countryList = this.countryListEnglish;
    }
  }

  parseProvinceState(provinceState) {

    if (this.provinceList.length > 0) {
      for (const provincelist of this.provinceList) {
        if (provincelist.provinceCode === provinceState) {
          return provincelist.id;
        }
      }
    }
    return provinceState;
  }

  checkCountry = () => {
    const country = this.employerForm.get('country').value;
    if (country === 'Canada') {

      this.isCanadaOrUsa = true;
      let newprovinceState;
      const currentlang = sessionStorage.getItem('currentLang');
      this.provinceList = currentlang === 'fr' ? this.provinceListCanadaFrench.slice(0) : this.provinceListCanada.slice(0);
      if (this.employerForm.value.provinceState && this.employerForm.value.provinceState.length !== 2) {
        newprovinceState = this.parseProvinceState(this.employerForm.value.provinceState);

      }
      else {
        newprovinceState = this.employerForm.value.provinceState;
      }
      // if (loading) {
      const provincestate = newprovinceState ? newprovinceState : this.provinceList[0].id;
      this.employerForm.get('provinceState').setValue(provincestate);
      // }
    }
    else if (country === 'USA') {
      this.isCanadaOrUsa = true;
      let newprovinceState;
      const currentlang = sessionStorage.getItem('currentLang');
      this.provinceList = currentlang === 'fr' ? this.provinceListUSAFrench : this.provinceListUSA;


      if (this.employerForm.value.provinceState && this.employerForm.value.provinceState.length !== 2) {
        newprovinceState = this.parseProvinceState(this.employerForm.value.provinceState);
      }
      else {
        newprovinceState = this.employerForm.value.provinceState;
      }

      // if (loading) {
      const provincestate = this.employerForm.value.provinceState ? newprovinceState : this.provinceList[0].id;
      this.employerForm.get('provinceState').setValue(provincestate);
      // }
    }
    else {
      this.isCanadaOrUsa = false;
      this.provinceList = [];
      const otherprovincestate = this.employerForm.value.provinceState;
      if (!this.employerForm.get('provinceState').value) {
        this.employerForm.get('provinceState').setValue('');
      }

    }
    // this.employerForm.get('employerPhoneNumber').setValue(undefined);
    /* const city = this.myInformationForm.get('city').value; */
    if (this.isCanadaOrUsa) {
      // this.myInformationForm.get('provinceState').setValidators([Validators.required, Validators.pattern(`^[A-Za-z0-9\-\Çéâêîôûàèùëïü./'#@%&:;,\\n ]*$`)]);
      this.employerForm.get('provinceState').setValidators([Validators.required]);
    } else {
      // this.myInformationForm.get('provinceState').setValidators(Validators.pattern(`^[A-Za-z0-9\-\Çéâêîôûàèùëïü./'#@%&:;,\\n ]*$`));
      this.employerForm.get('provinceState').setValidators(null);
    }
    this.employerForm.get('provinceState').updateValueAndValidity();


    if (country === 'USA' || country === 'Canada') {
      this.isCanadaOrUsa = true;
    } else {
      this.isCanadaOrUsa = false;
    }


  }


  ngOnChanges(changes: SimpleChanges) {

    const lang = sessionStorage.getItem('currentLang');

    if (lang) {
      this.dateAdapter.setLocale(lang);
    }

    const changeKey = Object.keys(changes);

    if (!this.employerForm.get('country').value) {
      const employerPhone = {
        number: '',
      };

      this.employerForm.get('country').setValue('Canada');
      this.employerForm.get('employerPhoneNumber').setValue(employerPhone);
      this.employerForm.get('provinceState').setValue('Ontario');
    }


    const userData = JSON.parse(sessionStorage.getItem('claim'));

    if (!this.pastEmployerInfo && !userData?.employmentInformation) {
      const localstoragejsonData = JSON.parse(sessionStorage.getItem('employmentData'));

      if (localstoragejsonData) {
        this.employerForm.get('employerAddress').setValue(localstoragejsonData.employerAddress);
        this.employerForm.get('employerName').setValue(localstoragejsonData.employerName);

        if (localstoragejsonData.employerAddress) {
          const countynamearray = localstoragejsonData.employerAddress.split(', ');
          const newCounty = countynamearray[countynamearray.length - 1];
          this.employerForm.get('country').setValue(countynamearray[countynamearray.length - 1]);

          const countrycode = this.countryCodeData.allCountries.find(x => {
            return String(x[0]).toLowerCase().split('(')[0].trim() === newCounty.toLowerCase().split('(')[0].trim();
          });


          const phone2 = {
            number: localstoragejsonData.employerPhoneNumber,
            countryCode: countrycode ? countrycode[countrycode.length - 1] : null,
          };

          this.employerForm.get('employerPhoneNumber').setValue(phone2);
        }

      }
    }


    if (this.pastEmployerInfo && !this.pastEmployerInfo.toolsUsedList) {
      this.tools = [];
    }


    if (this.pastEmployerInfo) {

      this.employerForm.value.employerPhoneNumber = this.pastEmployerInfo.employerPhoneNumber;


      if (this.employerForm.value.employerAddress) {


        const countyNameArray = this.employerForm.value.employerAddress.split(', ');
        const newCounty = countyNameArray[countyNameArray.length - 1];
        this.employerForm.get('country').setValue(countyNameArray[countyNameArray.length - 1]);

        const countryCode = this.countryCodeData.allCountries.find(x => {
          return String(x[0]).toLowerCase().split('(')[0].trim() === newCounty.toLowerCase().split('(')[0].trim();
        });

        if (this.pastEmployerInfo.employerPhoneNumber) {

          // const setNumber = this.pastEmployerInfo.employerPhoneNumber.split(' ');
          const phone1 = {
            number: this.pastEmployerInfo.employerPhoneNumber,
            countryCode: countryCode ? countryCode[countryCode.length - 1] : null,
          };

          this.employerForm.get('employerPhoneNumber').setValue(phone1);
        }
        else {
          const phone = {
            number: '',
            countryCode: countryCode ? countryCode[countryCode.length - 1] : null,
          };
          this.employerForm.get('employerPhoneNumber').setValue(phone);
        }
      }
    }


    if (this.pastEmployerInfo) {


      let countryCode = null;
      if (this.pastEmployerInfo.country) {
        countryCode = this.countryCodeData.allCountries.find(x => {
          return String(x[0]).toLowerCase().split('(')[0].trim() === this.pastEmployerInfo.country.toLowerCase().split('(')[0].trim();
        });
        if (!countryCode) {
          countryCode = this.countryCodeData.allCountries.find(x => {
            return String(x[0]).toLowerCase().split('(')[0].trim().indexOf(this.pastEmployerInfo.country.toLowerCase().split('(')[0].trim()) > -1;
          });
        }
      }

      let employerPhone = null;
      // if (this.pastEmployerInfo.employerPhoneNumber) {
      //   employerPhone = {
      //     "number": this.pastEmployerInfo.employerPhoneNumber,
      //     "countryCode": countryCode ? countryCode[1] : null
      //   }
      // }
      if (this.pastEmployerInfo.employerPhoneNumber) {
        const employerPhonesplitted = this.pastEmployerInfo.employerPhoneNumber.split(' ');
        employerPhone = {
          number: employerPhonesplitted ? employerPhonesplitted[1] : null,
          countryCode: countryCode ? countryCode[1] : null
        };
      }
      this.employerForm.patchValue({
        employerAddress: this.pastEmployerInfo.employerAddress,
        provinceState: this.pastEmployerInfo.provinceOrState,
        stillInBusiness: this.pastEmployerInfo.isEmployerInBusiness,
        employerName: this.pastEmployerInfo.employerName,
        employedTo: loadDateToMoment(this.pastEmployerInfo.employmentEndDate),
        employedFrom: loadDateToMoment(this.pastEmployerInfo.employmentStartDate),
        jobTitle: this.pastEmployerInfo.jobTitle,
        country: this.pastEmployerInfo.country,
        employerPhoneNumber: employerPhone,
      });
      this.employerForm.get('employerPhoneNumber').setValue(employerPhone);

      this.employedToMinimumDate = new Date(this.pastEmployerInfo.employmentStartDate.replace(/-/g, "/"));

      this.todate = new Date(this.pastEmployerInfo.employmentEndDate.replace(/-/g, "/"));
      // this.employerForm.get('employerAddress').setValue(this.pastEmployerInfo.employerAddress);
      // this.employerForm.get('stillInBusiness').setValue(this.pastEmployerInfo.isEmployerInBusiness);
      // this.employerForm.get('employerName').setValue(this.pastEmployerInfo.employerName);
      // this.employerForm.get('employedTo').setValue(this.pastEmployerInfo.employmentEndDate);
      // this.employerForm.get('employedFrom').setValue(this.pastEmployerInfo.employmentStartDate);
      // this.employerForm.get('jobTitle').setValue(this.pastEmployerInfo.jobTitle);
      // this.employerForm.get('country').setValue(this.pastEmployerInfo.country);
      // this.employerForm.get('provinceState').setValue(this.pastEmployerInfo.provinceOrState);
      // this.employerForm.get('employerPhoneNumber').setValue(employerPhone);

      this.fromdate = new Date(this.pastEmployerInfo.employmentStartDate.replace(/-/g, "/"));
      this.todate = new Date(this.pastEmployerInfo.employmentEndDate.replace(/-/g, "/"));
      this.tools = this.pastEmployerInfo.toolsUsedList;

    }

    this.checkCountry();
    this.updateCountryList();

  }

  // setEmployedToMinimumDate = (event) => {

  //   if (event.target.value) {
  //     let minDate = event.target.value._i;
  //     this.employedToMinimumDate = new Date(minDate.year, minDate.month, minDate.date);
  //     this.employerForm.get('employedTo').enable();
  //   }
  //   else
  //     this.employerForm.get('employedTo').disable();
  // }

   setBusinessMinimumDate(event) {
    if (!event.target.value) {
      this.employedToMinimumDate = new Date(1900, 0, 1);
    } else {
      let toDate;
      let fromDate : Date;
      let to;

      let  from = event.target.value._i;
      if (from.year) {
          fromDate = new Date(from.year, from.month, from.date);
      } else {
          // when input from keyboard, "2025-1-1" will be treated as UTC time, when showing in ui, it will be 
          // converted to local time, which may have one day shift. To avoid the issue, change it to "2025/1/1" 
          // as local time
          fromDate = new Date(from.replaceAll('-', '/'));
      }

      if (fromDate <= new Date(1900, 0, 1) || fromDate > new Date()) {
        fromDate = new Date(1900, 0, 1);
      }
      console.log(fromDate.toLocaleDateString());
      this.employedToMinimumDate = fromDate;
    }
  }

  onToolsListSubmit = () => {

    this.istoolform = true;

    this.toolsForm.markAllAsTouched();


    if (this.toolInput.valid) {
      this.toolsForm.get('toolName').setValue(this.toolInput.value);
    }

    if (this.toolsForm.get('hoursUsed').value && this.toolsForm.get('hoursUsed').value.match(/\./g)) {
      const count = (this.toolsForm.get('hoursUsed').value.match(/\./g).length);
      if (count > 1) {
        this.isNumber = true;
        return;
      }
      else if (count === 1 && !this.toolsForm.valid) {
        this.isNumber = true;
        return;
      }
      else { this.isNumber = false; }
    }

    if (this.toolsForm.valid) {
      // if (!this.isInValidHrs()) {
      const hoursUsed = this.toolsForm.get('hoursUsed').value;
      if (hoursUsed > 24 || hoursUsed < 0.1) {
        return;
      }

      // if (10 >= this.tools.length) {
      const toolList: Tools = {
        toolName: this.toolsForm.get('toolName').value,
        hoursUsed: this.toolsForm.get('hoursUsed').value,
        // hoursUsed: parseFloat((this.toolsForm.get('hoursUsed').value).toFixed(2))
      };

      this.tools = this.tools?[...this.tools, toolList]:[toolList];
      // console.log('this.tools>>>>>>>>', this.tools)
      this.toolsForm.reset();
      this.toolInput.reset();

      this.getToolFiltered();



      // } else {
      //   this.toolListOverLimit = true;
      //   this.toolsForm.reset();
      //   // console.log('over limit<<<<<<<<', this.toolListOverLimit)
      // }
      // }
    } else {
      this.validationService.validateAllFormFields(this.toolsForm);
    }
  }
  parseProvinceStateCode(provinceState) {
    if (this.provinceList.length > 0) {
      for (const provincelist of this.provinceList) {
        if (provincelist.id === provinceState) {
          return provincelist.provinceName;
        }
      }
    }
    return provinceState;
  }


  /**
   * @author Deivid Mafra;
   * @date 08/16/2020;
   * @remarks Method responsible for adding the end-user past employment information based on claimId.
   * It retrieves the entire claim object and storage it in the session storage.
   */

  addOrUpdatePastEmploymentInfo = () => {
    this.issubmitForm = true;

    // if (this.toolsForm.get('toolName').touched || this.toolsForm.get('hoursUsed').touched) {
    //   if (this.toolsForm.get('toolName').value == null || this.toolsForm.get('hoursUsed').value == null) {
    //     this.onToolsListSubmit();
    //     this.istoolform = false;
    //     return;
    //   }
    //   else {
    //     this.istoolform = true;
    //   }
    //   console.log(this.toolsForm.get('toolName').touched);
    //   console.log(this.toolsForm.get('hoursUsed').touched);
    // }
    if (this.toolInput.valid) {
      this.toolsForm.get('toolName').setValue(this.toolInput.value);
    }
    if (!this.toolsForm.get('toolName').value && !this.toolsForm.get('hoursUsed').value) {
      this.issubmit = false;
    }
    else if (!this.toolsForm.get('toolName').value && this.toolsForm.get('hoursUsed').value) {
      this.issubmit = true;
      return;
    }
    else if (this.toolsForm.get('toolName').value && !this.toolsForm.get('hoursUsed').value) {
      this.issubmit = true;
      return;
    }
    else {
      this.issubmit = false;
    }

    if (this.toolsForm.get('hoursUsed').value && this.toolsForm.get('hoursUsed').value.match(/\./g)) {
      const count = (this.toolsForm.get('hoursUsed').value.match(/\./g).length);
      if (count > 1) {
        this.isNumber = true;
        return;
      }
      else if (count === 1 && !this.toolsForm.valid) {
        this.isNumber = true;
        return;
      }
      else { this.isNumber = false; }
    }

    this.employerForm.markAllAsTouched();
    this.invalidHours = (this.toolsForm.value.toolName && !this.toolsForm.value.hoursUsed) ? true : false;
    if (this.employerForm.valid && !this.invalidHours) {

      this.onToolsListSubmit();


      let employerphonenumber = this.employerForm.get('employerPhoneNumber').value;
      // if (employerPhoneNumber) {
      //   employerPhoneNumber = employerPhoneNumber.number;
      // }
      if (employerphonenumber) {
        employerphonenumber = '(' + employerphonenumber.dialCode + ')' + ' ' + employerphonenumber.number;
      }
      const country = this.employerForm.get('country')?.value;
      let ProvinceState;
      if (country === 'USA' || country === 'Canada') {
        ProvinceState = this.parseProvinceStateCode(this.employerForm.get('provinceState').value);
      }
      else {
        ProvinceState = this.employerForm.get('provinceState').setValue(null);
      }
      const pastEmploymentInfo: PastEmployerInfoDTO = {
        employerAddress: this.employerForm.get('employerAddress').value,
        employerInBusiness: this.employerForm.get('stillInBusiness').value,
        employerName: this.employerForm.get('employerName').value,
        employmentEndDate: this.employerForm.get('employedTo')?.value?.format('YYYY-MM-DD'),
        employmentStartDate: this.employerForm.get('employedFrom')?.value?.format('YYYY-MM-DD'),
        jobTitle: this.employerForm.get('jobTitle').value,
        country: this.employerForm.get('country').value,
        provinceOrState: ProvinceState,
        employerPhoneNumber: employerphonenumber,
        toolsUsed: this.tools,
      };
      this.issubmit = false;
      this.lowerthanZero = false;
      this.greterthantwentyfor = false;
      this.greterthantwentyfor = false;
      this.isNumber = false;
      this.invalidHours = false;
      this.addOrUpdatePastEmployment.emit(pastEmploymentInfo);
      this.employerForm.reset({
        country: 'India',
        employerPhoneNumber: null,
        provinceState: null,
        employerName: null
      });
      setTimeout(() => {
        // const employerPhone = {
        //   "number": '',
        // }
        this.employerForm.get('country').setValue('Canada');
        // this.employerForm.get('employerPhoneNumber').setValue(employerPhone);
        this.employerForm.get('provinceState').setValue('Ontario');
      }, 0);
      setTimeout(() => {
        this.employerForm.reset();
      }, 0);

      this.cancelBtn.nativeElement.click();
      this.issubmitForm = false;

    }
  }

  getProvince(address) {
    for (const component of address.address_components) {
      if (component && component.types[0] === 'administrative_area_level_1') {
        return component.long_name;
      }
    }
  }

  resetAddressFields() {
    this.employerForm.get('employerAddress').setValue('');
    this.employerForm.get('provinceState').setValue('');
    this.employerForm.get('country').setValue('');
  }


  addressChange(address: any) {
    // console.log('adas sadasd', address.address_components);
    // this.checkCountry();
    /*this.myInformationForm.get('provinceState').setValue(''); */
    // if (this.employerForm.get('employerAddress') != null &&
    //   this.employerForm.get('country') != null) {
    //   this.resetAddressFields();
    // }
    let country = '';
    for (const component of address.address_components) {
      if (component.types.includes('country')) {
        country = component.long_name;
        break;
      }
    }
    const newProvince = this.getProvince(address);

    this.employerForm.get('employerAddress').setValue(this.removeCoutryFromFormattedAddress(address.formatted_address));

    const countyNameArray = address.formatted_address.split(', ');
    this.employerForm.get('country').setValue(country);
    const provinceStateNameArray = address.formatted_address.split(', ');


    // this.checkCountry();
    const splitAddress = address.formatted_address.split(',');
    const cleanSplitAddress: any = splitAddress.map(item => item.trim());
    const splitPostalCode = cleanSplitAddress[cleanSplitAddress?.length - 2]?.split(' ');
    if (country === 'Canada' || country === 'United States') {
      this.isCanadaOrUsa = true;
      this.employerForm.get('country').setValue( country === 'United States' ? 'USA':country );
      this.employerForm.get('provinceState').setValue(splitPostalCode[0]);
      this.checkCountry();
    } else {
      this.isCanadaOrUsa = false;
      const countryReturned = cleanSplitAddress.pop();
      // this.employerForm.get('country').setValue(countryReturned);
      this.checkCountry();
    }
    // const splitAddress = address.formatted_address.split(',');
    // console.log(splitAddress)
    // const cleanSplitAddress = splitAddress.map(item => item.trim());
    // const splitPostalCode = cleanSplitAddress[2]?.split(' ');
    // console.log(cleanSplitAddress);

    // this.employerForm.get('employerAddress').setValue(address.formatted_address);
    // // if (cleanSplitAddress[0].includes('-')) {
    // //   const newSplit = cleanSplitAddress[0].split('-');
    // //   this.employerForm.get('employerAddress').setValue(newSplit[1]);
    // // } else {
    // //   this.employerForm.get('employerAddress').setValue(cleanSplitAddress[0]);
    // // }

    // if (cleanSplitAddress[3] === 'Canada' || cleanSplitAddress[3] === 'USA') {
    //   this.isCanadaOrUsa = true;
    //   // this.inputValue = '+1';
    //   this.employerForm.get('country').setValue(cleanSplitAddress[3]);
    //   this.checkCountry();
    //   this.employerForm.get('provinceState').setValue(splitPostalCode[0]);
    //   // splitPostalCode[2] != null ? this.employerForm.get('postalCode').setValue(splitPostalCode[1] + ' ' + splitPostalCode[2]) :
    //   //   this.employerForm.get('postalCode').setValue(splitPostalCode[1]);

    // } else {
    //   this.isCanadaOrUsa = false;
    //   const countryReturned = cleanSplitAddress.pop();
    //   this.employerForm.get('country').setValue(countryReturned);
    //   this.employerForm.get('provinceState').setValue('');
    //   this.checkCountry();
    // }


    if (this.employerForm.get('employerPhoneNumber').value) {
      const phone1Data = this.employerForm.get('employerPhoneNumber').value;
      const phone1 = {
        number: phone1Data.number,
        countryCode: phone1Data.dialCode
      };
      this.employerForm.get('employerPhoneNumber').setValue(phone1);
    }
  }

  removeCoutryFromFormattedAddress(formattedAddress: string) {
    const splittedAddress = formattedAddress.split(',');
    if ( splittedAddress && splittedAddress.length > 1) {

      return formattedAddress.substring( 0 , formattedAddress.lastIndexOf(','));
    }
    return formattedAddress;
  }

  isFieldValid(form: UntypedFormGroup, field: string, splchk = null) {
    if (splchk === null) {
      return !form.get(field).valid && form.get(field).touched;
    } else {
      if (splchk) {
        return !form.get(field).valid && form.get(field).touched && !form.get(field).value;
      } else {
        return !form.get(field).valid && form.get(field).touched && form.get(field).value;
      }
    }
  }

  isFieldTouched(form: UntypedFormGroup, field: string, splchk = null) {
    if (form.get(field).touched) {
      return this.isFieldValid(form, field, splchk);
    }
  }

  displayFieldCss(form: UntypedFormGroup, field: string) {
    return {
      'has-error': (field !== 'hoursUsed') ? this.isFieldValid(form, field) : (this.isFieldValid(form, field))
    };
  }

  cancelEmploymentInfo = () => {
    this.employerForm.reset();
    this.toolsForm.reset();
    this.tools = [];
    this.issubmit = false;
    this.lowerthanZero = false;
    this.greterthantwentyfor = false;
    this.greterthantwentyfor = false;
    this.isNumber = false;
    this.invalidHours = false;
    this.employerForm.markAsUntouched();

  }




  isInvalidtool = (value) => {

    if (value) {
      this.isTool = true;
    } else {
      this.isTool = false;
      this.issubmit = false;
    }
  }


  isInValidHrs = (value) => {

    const format = /[A-Za-z `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/;
    this.isNumber = format.test(this.toolsForm.get('hoursUsed').value);

    const n = /[.!?]$/.test(value);


    if (n === true) {
      if (!this.checkDot) {
        this.isNumber = false;
      } else { this.isNumber = true; }
      this.checkDot = true;
    } else { this.checkDot = false; }
    if (format.test(this.toolsForm.get('hoursUsed').value) || this.isNumber) {
      this.isNumber = true;
    }

    if (n) {
      const count = (value.match(/\./g).length);
      count > 1 || format.test(this.toolsForm.get('hoursUsed').value) ? this.isNumber = true : this.isNumber = false;
    }

    if (this.toolsForm.valid) {
      this.istoolform = true;
    }

    if (this.toolsForm) {
      const hoursUsed = value;

      if (hoursUsed > 24 || hoursUsed == null) {
        this.lowerthanZero = false;
        this.greterthantwentyfor = true;
      }
      if (hoursUsed < 0.1 || hoursUsed == null) {
        this.lowerthanZero = true;
        this.greterthantwentyfor = false;
      }
      if (hoursUsed >= 0.1 && hoursUsed <= 24) {
        this.lowerthanZero = false;
        this.greterthantwentyfor = false;
      }
    }

    if (!this.toolsForm.get('hoursUsed').value) {
      this.issubmit = false;
      this.lowerthanZero = false;
      this.greterthantwentyfor = false;
      this.greterthantwentyfor = false;
      this.isNumber = false;
      this.invalidHours = false;
    }
  }


  // private getAllTools = () => {

  //   let engTools: string[] = [];
  //   let frcTools: string[] = [];

  //   this.pastEmploymentService.getAllTools().subscribe(
  //     res => {

  //       if (sessionStorage.getItem('currentLang') == 'en') {
  //         console.log('ENGLISH', this.currentLang);

  //         for (let i = 0; i < res.length; i++) {
  //           engTools.push(res[i].toolEnName);
  //         }
  //         this.toolList = engTools;
  //         console.log('this.toolList', this.toolList)
  //       } else {
  //         console.log('FRENCH', this.currentLang);
  //         for (let i = 0; i < res.length; i++) {
  //           frcTools.push(res[i].toolFrName);
  //         }
  //         this.toolList = frcTools;
  //         console.log('this.toolList in french', this.toolList)
  //       }
  //       this.getToolFiltered();
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //   )
  //   // }
  // }

  getToolFiltered = () => {
    this.filteredOptions = this.toolInput.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  private _filter(value: string): string[] {
    if (value) {
      const filterValue = value.toLowerCase();
      return this.predefinedToolList.filter(option => option.toLowerCase().includes(filterValue));
    }
  }


  /*double check */
  onToolsListdelete = (item: Tools) => {
    const index = this.tools.findIndex((x: Tools) => x === item);
    this.tools.splice(index, 1);
  }
}
